export default __webpack_public_path__ + "static/media/embedded_view_instructions_dark.5b6d536b.svg";